import { create } from "zustand";
import { persist } from "zustand/middleware";

export type MetaAttribution = {
  fbp?: string;
  fbc?: string;
  fbclid?: string;
};

export type MetaAttributionStoreState = MetaAttribution & {
  setMetaAttribution: (attribution: MetaAttribution) => void;
};

export const useMetaAttributionStore = create<MetaAttributionStoreState>()(
  persist(
    (set) => {
      return {
        fbp: undefined,
        fbc: undefined,
        fbclid: undefined,
        setMetaAttribution: (attribution: MetaAttribution) => {
          set((state) => {
            return {
              fbp: attribution.fbp ?? state.fbp,
              fbc: attribution.fbc ?? state.fbc,
              fbclid: attribution.fbclid ?? state.fbclid,
            };
          });
        },
      };
    },
    {
      name: "metaAttributionStore",
    },
  ),
);

export const getMetaAttributionStoreState = () => {
  return useMetaAttributionStore.getState();
};
